import { createSlice, createListenerMiddleware, type Action } from '@reduxjs/toolkit';
import { AppRootState } from '@/configureStore';

const completedTypes = ['/fulfilled', '/idle', '/rejected'];

export const activitysSlice = createSlice({
  name: 'activity',
  initialState: {
    isActive: false
  },
  reducers: {
    active: (state) => {
      return {
        ...state,
        isActive: true
      };
    },
    completed: (state) => {
      return {
        ...state,
        isActive: false
      };
    }
  }
});

export const selectIsActive = (state: AppRootState) => state?.activity?.isActive ?? false;
export const activityMiddleware = createListenerMiddleware();

const isPendingAction = (action: Action) => action.type.endsWith('/pending');
const isCompletedAction = (action: Action) => completedTypes.some((type) => action.type.endsWith(type));

activityMiddleware.startListening({
  predicate: (action /*, currentState, previousState */) => {
    const isPending = isPendingAction(action);
    const isCompleted = isCompletedAction(action);
    return isPending || isCompleted;
  },
  effect: (action, { getState, dispatch /* , getOriginalState */ }) => {
    const currentActive = selectIsActive(getState() as AppRootState);

    const isPending = isPendingAction(action);
    const isCompleted = isCompletedAction(action);

    if (isPending && !currentActive) {
      const nextAction = activitysSlice.actions.active();
      dispatch(nextAction);
    }
    if (isCompleted && currentActive) {
      const nextAction = activitysSlice.actions.completed();
      dispatch(nextAction);
    }
  }
});
